import { Center, Stack, Text, Box } from "@mantine/core";
import AuthForm from "components/auth/auth-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppTranslation } from "hooks/useTranslation";
import { safeReturnPath } from "utils";

export const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useAppTranslation();

  const loginSuccess = () => {
    // AuthRoute preserves the requested path here when it bounces an
    // unauthenticated visitor. It is untrusted input, so it only ever reaches
    // navigate() through safeReturnPath, which owns the /events fallback.
    const state: unknown = location.state;
    const preserved =
      typeof state === "object" && state !== null && "path" in state
        ? (state as { path: unknown }).path
        : undefined;
    // replace: true — the login screen must not sit in history behind the
    // destination.
    navigate(safeReturnPath(preserved), { replace: true });
  };
  return (
    <Center>
      <Stack>
        <img
          src="/images/logo.png"
          alt="Admin Logo"
          style={{
            marginTop: "50px",
            height: "170px",
            borderRadius: 10,
          }}
        />
        <h1 className="header">Organisers Access </h1>
        <AuthForm onLoginSuccess={loginSuccess} />
        <Box mt={30}>
          <Text size="sm" color="dimmed" ta="center">
            {t("auth.get_access")}{" "}
            <a href="mailto:contact@pasemana.pt">contact@pasemana.pt</a>
          </Text>
        </Box>
      </Stack>
    </Center>
  );
};
